module.exports = __webpack_public_path__ + "img/img32.8e26bd6e.jpg";